"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var lodash_1 = __importDefault(require("lodash"));

var remote_groups_1 = __importDefault(require("../constants/actions/remote-groups"));

var auth_1 = __importDefault(require("../constants/actions/auth"));

var remote_group_edit_1 = __importDefault(require("../constants/actions/remote-group-edit"));

var UtilsArray = __importStar(require("../utils/array"));

var UtilsRemoteGroup = __importStar(require("../utils/remote-group"));

function default_1() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    list: [],
    error_on_get_list: null,
    error_on_add: null,
    error_on_reload: null,
    is_loading: false,
    is_reloading: false
  };
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case remote_groups_1.default.GET_LIST_INIT:
      return Object.assign({}, state, {
        is_loading: true
      });

    case remote_groups_1.default.GET_LIST_SUCCESS:
      {
        var list = action.list;
        return Object.assign({}, state, {
          list: list,
          is_loading: false
        });
      }

    case remote_groups_1.default.GET_LIST_FAILURE:
      return Object.assign({}, state, {
        is_loading: false,
        error_on_get_list: action.error_id
      });

    case remote_groups_1.default.RELOAD_INIT:
      return Object.assign({}, state, {
        list: [],
        is_reloading: true
      });

    case remote_groups_1.default.RELOAD_SUCCESS:
      return Object.assign({}, state, {
        list: action.list,
        is_reloading: false
      });

    case remote_groups_1.default.RELOAD_FAILURE:
      return Object.assign({}, state, {
        is_reloading: false,
        error_on_reload: action.error
      });

    case remote_groups_1.default.ON_GROUP_UPDATE:
      {
        var data = action.data;

        if (data) {
          return Object.assign({}, state, {
            list: UtilsArray.replaceByProps(state.list, {
              id: data.id
            }, data)
          });
        } else {
          return Object.assign({}, state, {
            list: UtilsArray.removeByProps(state.list, {
              id: action.group_id
            })
          });
        }
      }

    case remote_groups_1.default.ADD_INIT:
      return Object.assign({}, state, {
        is_loading: true
      });

    case remote_group_edit_1.default.ADD_SUCCESS:
    case remote_groups_1.default.ADD_SUCCESS:
      {
        return Object.assign({}, state, {
          list: UtilsArray.unshift(state.list, action.group_data),
          is_loading: false
        });
      }

    case remote_groups_1.default.ADD_FAILURE:
      return Object.assign({}, state, {
        is_loading: false,
        error_on_add: action.error
      });

    case remote_groups_1.default.EDIT_INIT:
      return Object.assign({}, state, {
        is_loading: true
      });

    case remote_group_edit_1.default.EDIT_SUCCESS:
    case remote_groups_1.default.EDIT_SUCCESS:
      return Object.assign({}, state, {
        is_loading: false,
        list: UtilsArray.replaceByProps(state.list, {
          id: action.group_id
        }, action.group_data)
      });

    case remote_groups_1.default.EDIT_FAILURE:
      return Object.assign({}, state, {
        is_loading: false
      });

    case remote_groups_1.default.REMOVE_INIT:
      return Object.assign({}, state, {
        is_loading: true
      });

    case remote_groups_1.default.REMOVE_SUCCESS:
      return Object.assign({}, state, {
        is_loading: false,
        list: lodash_1.default.filter(state.list, function (u) {
          return u.id !== action.group_id;
        })
      });

    case remote_groups_1.default.REMOVE_FAILURE:
      return Object.assign({}, state, {
        is_loading: false
      });

    case auth_1.default.SIGN_OUT_SUCCESS:
      return Object.assign({}, state, {
        list: []
      });

    case remote_groups_1.default.RESET_NEW_PENDING_ITEMS_COUNTER_SUCCESS:
      {
        var _list = [];
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = state.list[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var group = _step.value;

            if (group.id === action.group_id) {
              _list.push(UtilsRemoteGroup.resetNewPendingItemsCounter(group));
            } else {
              _list.push(group);
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        return Object.assign({}, state, {
          list: _list
        });
      }

    default:
      return state;
  }
}

exports.default = default_1;